import { z } from "zod";

import { ApiSuccessSchema } from "../../common/response.schema";

const CueSnapshotAvailableResponseSchema = z.object({
  available: z.boolean()
});

export type CueSnapshotAvailableResponse = z.infer<typeof CueSnapshotAvailableResponseSchema>;

/**
 * ZCueSnapshot — snapshot availability pre-flight check.
 *
 * The frontend calls this before opening a Cue session to decide whether to
 * show the chat UI or the Maintenance panel. `available: false` means the Cue
 * snapshot is absent (e.g. a same-name rebuild is in flight); Cue should
 * surface a "back in ~15 minutes" state until `refetchOnWindowFocus` clears it.
 */
export const ZCueSnapshot = {
  GetAvailable: {
    method: "GET" as const,
    path: "/api/virtual-employees/cue/snapshot/available",
    Response: ApiSuccessSchema(CueSnapshotAvailableResponseSchema)
  }
} as const;
